import { Controller } from "stimulus"
export default class extends Controller {
  toggleMobileNav() {
    const mobileNav = document.querySelector('.main-nav')
    const hamburgerIcon = document.querySelector('.hamburger-menu')
    hamburgerIcon.classList.toggle('active') 
    mobileNav.classList.toggle('active')
  }
}